var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 4.66667V2H1.33398V14H14.6673V4.66667H8.00065ZM4.00065 12.6667H2.66732V11.3333H4.00065V12.6667ZM4.00065 10H2.66732V8.66667H4.00065V10ZM4.00065 7.33333H2.66732V6H4.00065V7.33333ZM4.00065 4.66667H2.66732V3.33333H4.00065V4.66667ZM6.66732 12.6667H5.33398V11.3333H6.66732V12.6667ZM6.66732 10H5.33398V8.66667H6.66732V10ZM6.66732 7.33333H5.33398V6H6.66732V7.33333ZM6.66732 4.66667H5.33398V3.33333H6.66732V4.66667ZM13.334 12.6667H8.00065V11.3333H9.33398V10H8.00065V8.66667H9.33398V7.33333H8.00065V6H13.334V12.6667ZM12.0007 7.33333H10.6673V8.66667H12.0007V7.33333ZM12.0007 10H10.6673V11.3333H12.0007V10Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.e79584343837ed6d1f598c82e323e8b8.svg";
export { ForwardRef as ReactComponent };